module.exports = __webpack_public_path__ + "static/img/7.bef4a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/7.jpg
// module id = N6+d
// module chunks = 29